import { Component } from '@angular/core';
import { CoreService } from 'src/app/shared/services/core.service';
import { RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-branding',
  imports: [RouterModule],
  template: `
    <a [routerLink]="['/']" class="col-12" style="padding:0;display:flex; flex-direction:row; align-items:center;justify-content:center">

      <img 
       [src]="isSnEnvironment()?'assets/images/logos/StarNeon-Logo.png':'./assets/images/logos/logo-light.svg'"
        class="align-middle "
        style="margin-top: 10%;"
        [style.width]="isSnEnvironment() ? '25%' : ''"
        [style.marginBottom]="isSnEnvironment() ? '0%' : '5%'"
        alt="logo"
      />
    </a>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();
  environment = environment.apiUrl
  
  isSnEnvironment(){
    return (this.environment ?? '').includes('snapi');
  }
  constructor(private settings: CoreService) {}
}
